import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TERRITORIES } from "../../data/content";
import { Reveal } from "../MaskedLine";

const GROUNDS = ["ground-lab", "ground-highlighter", "ground-margin", "ground-paper"];

export default function CapabilityTerritories() {
  return (
    <section data-testid="territories-section" className="ground-paper sec-pad border-t border-[color:var(--line-soft)]">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <p className="stamp mb-4" style={{ fontSize: 12 }}>What we help teams develop</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.4vw, 46px)", lineHeight: 1.08 }}>
              Four areas of capability development.
            </h2>
          </div>
          <p className="font-body-serif measure-narrow text-[#383D5A]" style={{ fontSize: 17 }}>
            Each programme has a defined audience, workplace application and agreed scope.
          </p>
        </div>

        <div className="border-t-[1.5px] border-[color:var(--ink)] grid grid-cols-1 md:grid-cols-2">
          {TERRITORIES.map((t, i) => (
            <Reveal key={t.slug} delay={(i % 2) * 0.05}>
              <Link
                to={`/programs/${t.programs[0]}`}
                data-testid={`territory-card-${t.slug}`}
                className={`group ${GROUNDS[i]} p-8 md:p-10 block h-full border-b-[1.5px] border-[color:var(--ink)] ${i % 2 === 1 ? "md:border-l-[1.5px]" : ""}`}
              >
                <div className="flex items-start justify-between">
                  <span className="stamp" style={{ fontSize: 12 }}>Territory {t.number}</span>
                  <ArrowUpRight size={22} className="text-[#0E1330] transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <h3 className="font-hook mt-8" style={{ fontSize: "clamp(26px, 2.6vw, 34px)", lineHeight: 1.05, letterSpacing: "-0.015em" }}>
                  {t.title}
                </h3>
                <p className="font-body-serif mt-4 measure text-[#0E1330]" style={{ fontSize: 17, lineHeight: 1.6 }}>
                  {t.body}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex justify-end">
          <Link to="/programs" className="btn-outline" data-testid="territories-cta">
            Explore all capabilities <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
